/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const howFamiliarGlp = useStore((state) => state.howFamiliarGlp);
  const setHowFamiliarGlp = useStore((state) => state.setHowFamiliarGlp);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.howFamiliar.title')}</Title>
        <Text size='m' medium className='description'>
          {t('onboarding.howFamiliar.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={howFamiliarGlp}
          onChange={(value: string) => {
            setHowFamiliarGlp(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'how-familiar',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Beginner'}>{t('onboarding.howFamiliar.options.beginner')}</Option>
          <Option value={'Intermediate'}>{t('onboarding.howFamiliar.options.intermediate')}</Option>
          <Option value={'Experienced'}>{t('onboarding.howFamiliar.options.experienced')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
